import { initializeControlAgeButtons } from '../../control/ageGroup';
import { countTotalParty } from '../../utils';
import { populateFromQueryParamsOrLocalStorage } from '../infrastructure/populator';
import { ageManager, watchAgeFields } from './components/ageType';
import { coverTypeEventManager } from './components/coverType';
import { initDatePicker } from './components/datePicker';
import { destinationTypeEventManager } from './components/destination';
import { modeTypeEventManager } from './components/modeType';
import { discountCodeEventManager } from './components/sourceCode';
function formSubmitHandler(form, callback) {
    const formElement = document.getElementById('quote-form');
    formElement.addEventListener('submit', (event) => {
        event.preventDefault();
        countTotalParty(form);
        callback();
    });
}
export function addActiveClassToRadios(form, callback) {
    // retrieve from the cached data
    const [startPicker, endPicker] = initDatePicker(form);
    populateFromQueryParamsOrLocalStorage(form, startPicker, endPicker);
    // !!! START HERE
    // !!! REMOVE THIS CODE ONCE THE VARIANT WON
    initializeControlAgeButtons(form);
    // attach event listeners to the form elements
    coverTypeEventManager(form, startPicker, endPicker);
    destinationTypeEventManager(form);
    discountCodeEventManager(form);
    formSubmitHandler(form, callback);
    watchAgeFields(form, null);
    // for age interceptors
    modeTypeEventManager(form);
    ageManager(form);
}
